var lx = lx || {};

lx.employee = {
    manage: {
        reemploy: function(pMsg) {

            lx.info.actionConfirm({
                type: "warning",
                msg: pMsg,
                js: "apex.page.submit( 'REEMPLOY' );"
            });
        },
        archive: function() {
			apex.theme.closeRegion( "uiArchiveConnection" );
            lx.info.actionConfirm({
                type: "warning",
                msg: lx.tran.get("EMP_CHARGES_ARCHIVE"),
                js: "apex.page.submit( 'ARCHIVE' );"
            });
        }
    }
}